import React from "react";
import { useFieldWrapper } from "../hooks";
import DoubleComponent from "./DoubleComponent";
import FormFieldNumber from "./FormFieldNumber";
import IntegerComponent from "./IntegerComponent";
import { NumberComponentProps } from "./NumberComponent";

export const DoubleComponentWrapper = (props: NumberComponentProps) => {
	const WrappedComponent = useFieldWrapper(DoubleComponent, FormFieldNumber);
	return <WrappedComponent {...props} />;
};

export const IntegerComponentWrapper = (props: NumberComponentProps) => {
	const WrappedComponent = useFieldWrapper(IntegerComponent, FormFieldNumber);
	return <WrappedComponent {...props} />;
};
